import {handleEmailSending} from "../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const OpayCeoContactEmail = () => {

    const name = fromCharCode(99, 101, 111);
    const domain = fromCharCode(111, 112, 97, 121, 46, 101, 117);

    return (
        <>
            <a className="contact-by-email" href='#' onClick={(e) => handleEmailSending(e, name, domain)}>
                {`${fromCharCode(99, 101, 111, 64, 111, 112, 97, 121, 46, 101, 117)}`}
            </a>
        </>
    )
}

export default OpayCeoContactEmail;
